module.exports = __webpack_public_path__ + "img/inbox-info.4a01dbdc.svg";